export const RESTART_DEADLINE_MS = 24 * 60 * 60 * 1000;

export function updateStateLabel(state: string, translate: (key: string, options?: any) => string): string {
  return state === 'idle' ? translate('resources.kiosk-devices.update.idle') : translate(`resources.kiosk-releases.installStates.${state}`);
}

export type ReaderState = 'ready' | 'connecting' | 'error' | 'stopped';

const READER_STATES: ReaderState[] = ['ready', 'connecting', 'error', 'stopped'];

export function readerStateOf(health: Record<string, unknown>): ReaderState | null {
  const reader = health.reader;
  if (reader === null || reader === undefined || typeof reader !== 'object') return null;
  const state = (reader as { state?: unknown }).state;
  return typeof state === 'string' && (READER_STATES as string[]).includes(state) ? (state as ReaderState) : null;
}
